export interface IconProps {
  size?: number;
  stroke?: string;
  strokeWidth?: number;
  className?: string;
}

const ChevronsUpDownIcon = ({
  size = 24,
  stroke = 'currentColor',
  strokeWidth = 3,
  className,
}: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={size}
    height={size}
    fill="none"
    stroke={stroke}
    strokeWidth={strokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
  >
    <path d="m7 15 5 5 5-5" />
    <path d="m7 9 5-5 5 5" />
  </svg>
);

export default ChevronsUpDownIcon;
